import { render } from "./CvBox.vue?vue&type=template&id=09d5821d&scoped=true"
import script from "./CvBox.vue?vue&type=script&lang=js"
export * from "./CvBox.vue?vue&type=script&lang=js"

import "./CvBox.vue?vue&type=style&index=0&id=09d5821d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d5821d"]])

export default __exports__